const embedHeight = (src) => {
  if (src.includes("bandcamp")) return "h-[470px]";
  if (src.includes("mixcloud")) return "h-[180px]";
  if (src.includes("soundcloud")) return "h-[166px]";
  if (src.includes("spotify")) return "h-[352px]";
  return "aspect-video";
};

const Block = ({ p }) => {
  if (p.startsWith("## ")) return <h2 className="font-display uppercase text-2xl md:text-3xl text-white pt-4">{p.slice(3)}</h2>;
  if (p.startsWith("> ")) return <blockquote className="border-l-4 border-primary pl-6 italic text-white text-lg md:text-xl leading-relaxed">{p.slice(2)}</blockquote>;
  if (p.startsWith("img:")) return <img src={p.slice(4)} alt="" loading="lazy" className="w-full max-w-[640px] h-auto" />;
  return <p className="text-zinc-300 text-base md:text-lg leading-relaxed">{p}</p>;
};

export const RichContent = ({ content = [], fallback, embeds = [] }) => {
  const blocks = content.length ? content : fallback ? [fallback] : [];
  return (
    <div className="space-y-6" data-testid="rich-content">
      {blocks.map((p, i) => <Block key={i} p={p} />)}
      {embeds.map((src, i) => (
        <div key={src + i} className={`w-full ${embedHeight(src)} bg-[hsl(var(--surface))]`}>
          <iframe src={src} title={`media-${i}`} className="w-full h-full" loading="lazy" allow="autoplay; encrypted-media" allowFullScreen data-testid={`embed-${i}`} />
        </div>
      ))}
    </div>
  );
};
